import http from '../http';
import {api} from '../api';
import {
  GetPredictionsByDateBody,
  PredictionDetailsItemType,
  PredictionsByDateData,
} from '../../interfaces/api/predictions';
import {store} from '../../redux/store';
import {HttpResponse} from '../../interfaces/api/http';

export const predictions = {
  getById: (id: number): Promise<HttpResponse<PredictionDetailsItemType>> =>
    new Promise((resolve, reject) => {
      const url = `${api.predictions.getById}${id}`;
      http
        .get<PredictionDetailsItemType>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),

  getByDate: ({
    tabId,
    dateFrom,
    dateTo,
    page,
    filters,
  }: GetPredictionsByDateBody): Promise<HttpResponse<PredictionsByDateData>> =>
    new Promise((resolve, reject) => {
      const {specialty_id} = store.getState().auth?.currentUser || {};
      const params = new URLSearchParams();
      if (!tabId || !specialty_id) {
        throw new Error('tab id and specialty id are required');
      }
      params.append('tab_id', tabId.toString());
      params.append('specialty_id', specialty_id.toString());
      Object.keys(filters || {}).forEach(key => {
        if (
          filters[key] &&
          (key === 'specialty_id' ||
            key === 'type_of_study_id' ||
            key === 'resource_id')
        ) {
          params.append(key, String(filters[key]));
        }
      });
      params.append('dateFrom', dateFrom.toString());
      if (dateTo) {
        params.append('dateTo', dateTo.toString());
      }

      if (page) {
        params.append('page', page.toString());
        params.append('pageSize', '10');
      }
      const url = `${api.predictions.getByDateRange}?${params.toString()}`;
      http
        .get<PredictionsByDateData>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
